import { useState } from 'react';
import { Button, Col, Row, CardHeader } from 'reactstrap';
import { ReactComponent as Moneyhub } from '../../Assets/icons/moneyhub.svg';
import { IoCloudUploadOutline, IoRefreshOutline } from 'react-icons/io5';
import FileModal from '../FileModal';

const DashboardActions = ({ onRefresh }) => {
    const [showImport, setShowImport] = useState(false);

    return (
        <>
            <CardHeader className="pt-3 pb-3">
                <Row>
                    <Col xs="6" className="page-header">
                        Dashboard
                    </Col>
                    <Col xs="6" className="text-end pe-4">
                        <Button size="sm" color="info" className="me-1 btn-text" onClick={onRefresh}>
                            <IoRefreshOutline size={24} style={{ color: '#111' }} />
                        </Button>
                        <Button size="sm" color="dark" className="me-1 btn-text" onClick={() => setShowImport(true)}>
                            <IoCloudUploadOutline size={24} style={{ color: '#fff' }} />
                        </Button>
                        <Button size="sm" className="btn-text" onClick={() => window.open('https://client.moneyhub.co.uk/#')}>
                            <Moneyhub />
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            {showImport && (
                <FileModal
                    closeModal={() => setShowImport(false)}
                    onImported={() => {
                        setShowImport(false);
                        onRefresh();
                    }}
                />
            )}
        </>
    );
};

export default DashboardActions;
